import { Observable } from 'rxjs/Observable';
import { Injectable, OnChanges } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AutoUserService {

  constructor(
    public apiService: ApiService,
    private httpClient: HttpClient
  ) { }

  checkUserExists(userId: number) {

  }

  fetch(data: any, space: string): Promise<any> {
    const res: any = this.apiService.fetchData('/common/auto-complete/sign/user', data);
    return res;
  }

  fetchAuto(keyword: string, contractId?: string) {
    if (contractId) {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/sign/user?filter=${encodeURI(keyword)}&contractId=${contractId}`);
      return res;
    } else {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/sign/user?filter=${encodeURI(keyword)}`);
      return res;
    }
  }

  fetchAutoForwardSign(keyword: string, contractId?: string) {
    if (contractId) {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/approve/user?filter=${encodeURI(keyword)}&contractId=${contractId}`);
      return res;
    } else {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/approve/user?filter=${encodeURI(keyword)}`);
      return res;
    }
  }


  fetchAutoSignatureProcess(keyword: string, contractId?: string) {
    if (contractId) {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/user/approve?filter=${encodeURI(keyword)}&contractId=${contractId}`);
      return res;
    } else {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/user/approve?filter=${encodeURI(keyword)}`);
      return res;
    }
  }

  fetchAutoDepartment(keyword: string, contractId?: string) {
    if (contractId) {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/sign/user-departmen?filter=${encodeURIComponent(keyword)}&contractId=${contractId}`);
      return res;
    } else {
      const res = this.apiService.fetchDataAuto(`/common/auto-complete/sign/user-department?filter=${encodeURIComponent(keyword)}`);
      return res;
    }
  }
  fetchConfigNotification(keyword: string) {
      const res = this.apiService.fetchDataAuto(`/notification-enterprise/search-user-department?filter=${encodeURIComponent(keyword)}`);
      return res;
  }

}
